/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AcademicSection model module.
 * @module model/AcademicSection
 * @version 1.0.0
 */
class AcademicSection {
    /**
     * Constructs a new <code>AcademicSection</code>.
     * Academic Section
     * @alias module:model/AcademicSection
     * @param id {Number} 
     * @param title {String} 
     */
    constructor(id, title) { 
        
        AcademicSection.initialize(this, id, title);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, title) { 
        obj['id'] = id;
        obj['title'] = title;
    }

    /**
     * Constructs a <code>AcademicSection</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AcademicSection} obj Optional instance to populate.
     * @return {module:model/AcademicSection} The populated <code>AcademicSection</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AcademicSection();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('identifier')) {
                obj['identifier'] = ApiClient.convertToType(data['identifier'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('start_date')) {
                obj['start_date'] = ApiClient.convertToType(data['start_date'], 'Date');
            }
            if (data.hasOwnProperty('end_date')) {
                obj['end_date'] = ApiClient.convertToType(data['end_date'], 'Date');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
AcademicSection.prototype['id'] = undefined;

/**
 * @member {String} identifier
 */
AcademicSection.prototype['identifier'] = undefined;

/**
 * @member {String} title
 */
AcademicSection.prototype['title'] = undefined;

/**
 * @member {Date} start_date
 */
AcademicSection.prototype['start_date'] = undefined;

/**
 * @member {Date} end_date
 */
AcademicSection.prototype['end_date'] = undefined;

/**
 * @member {Number} status
 */
AcademicSection.prototype['status'] = undefined;

/**
 * @member {Boolean} enabled
 */
AcademicSection.prototype['enabled'] = undefined;






export default AcademicSection;

